import { getTimeRange } from '../../../../../../constants/helpers/dates';

import { AccountTransfersReportCreateForm } from './interfaces';

export const mapTableDataIntoApiFormat = (report: AccountTransfersReportCreateForm) => ({
  name: report.name,
  metadata: {
    timeRange: getTimeRange({ from: report.from, to: report.to }),
    statuses: report.statuses,
    operationIds: report.operationIds,
    sendersMsisdns: report.sendersMsisdns
  }
});
